import { render, staticRenderFns } from "./verification-orders-list.vue?vue&type=template&id=2dd4c39f&scoped=true&"
import script from "./verification-orders-list.vue?vue&type=script&lang=js&"
export * from "./verification-orders-list.vue?vue&type=script&lang=js&"
import style0 from "./verification-orders-list.vue?vue&type=style&index=0&id=2dd4c39f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4c39f",
  null
  
)

export default component.exports